import React from 'react';

interface CardContentProps {
  className?: string;
  children?: React.ReactNode;
  sx?: React.CSSProperties;
}

const CardContent: React.FC<CardContentProps> = ({ className = '', children, sx }) => {
  return (
    <div className={`p-4 ${className}`} style={sx}>
      {children}
    </div>
  );
};

export default CardContent;

